module.exports = __webpack_public_path__ + "static/media/1.39d154ac.jpg";